/* Craftmark design snapshot: attaches a picture of the live preview to the cart line
   (line-item property "Design Preview") for the custom pipe marker and valve tag builders. */
(function () {
  'use strict';
  var IDS = ['specmark_flat_svg', 'duramark_flat_svg', 'rollmark_roll_svg', 'rollv_roll_svg', 'vtag_alone_svg', 'specmark_preview_svg', 'duramark_preview_svg', 'rollv_pipe_svg', 'cm_tape_svg', 'cm_tag_svg', 'cm_decal_svg'];
  var PROPS = ['fill', 'fill-opacity', 'fill-rule', 'stroke', 'stroke-width', 'stroke-opacity', 'stroke-dasharray', 'stroke-linecap', 'stroke-linejoin',
    'opacity', 'font-family', 'font-size', 'font-weight', 'font-style', 'letter-spacing', 'text-anchor', 'dominant-baseline', 'alignment-baseline',
    'display', 'visibility', 'stop-color', 'stop-opacity', 'mix-blend-mode', 'filter'];
  var OUT_W = 1000, PAD = 24, GAP = 28;
  var snap = { key: null, url: null }, passThrough = false, fontCss = null;

  function targets() {
    var list = [];
    IDS.forEach(function (id) {
      var s = document.getElementById(id);
      if (!s) return;
      var r = s.getBoundingClientRect();
      if (r.width < 20 || r.height < 10) return;
      var cs = getComputedStyle(s);
      if (cs.display === 'none' || cs.visibility === 'hidden') return;
      list.push(s);
    });
    // keep page order (top to bottom)
    list.sort(function (a, b) { return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1; });
    return list;
  }

  function toDataUrl(url) {
    return fetch(url, { mode: 'cors' }).then(function (r) { return r.blob(); }).then(function (b) {
      return new Promise(function (ok) { var fr = new FileReader(); fr.onload = function () { ok(fr.result); }; fr.onerror = function () { ok(null); }; fr.readAsDataURL(b); });
    }).catch(function () { return null; });
  }

  function loadFontCss() {
    if (fontCss !== null) return Promise.resolve(fontCss);
    var rules = [];
    Array.prototype.forEach.call(document.styleSheets, function (ss) {
      try { Array.prototype.forEach.call(ss.cssRules, function (r) { if (r.type === 5 && /Helvetica Bold Craftmark/i.test(r.cssText)) rules.push(r); }); } catch (e) {}
    });
    if (!rules.length) { fontCss = ''; return Promise.resolve(fontCss); }
    return Promise.all(rules.map(function (r) {
      var m = r.style.getPropertyValue('src').match(/url\(["']?([^"')]+)["']?\)/);
      if (!m) return '';
      var u = m[1]; if (u.indexOf('//') === 0) u = location.protocol + u;
      return toDataUrl(u).then(function (d) {
        return d ? '@font-face{font-family:"Helvetica Bold Craftmark";font-weight:' + (r.style.getPropertyValue('font-weight') || '700') + ';font-style:normal;src:url(' + d + ')}' : '';
      });
    })).then(function (a) { fontCss = a.join(''); return fontCss; });
  }

  function cloneSvg(svg) {
    var r = svg.getBoundingClientRect();
    var c = svg.cloneNode(true);
    var src = [svg].concat(Array.prototype.slice.call(svg.querySelectorAll('*')));
    var dst = [c].concat(Array.prototype.slice.call(c.querySelectorAll('*')));
    for (var i = 0; i < src.length && i < dst.length; i++) {
      var cs = getComputedStyle(src[i]), st = '';
      PROPS.forEach(function (p) {
        var v = cs.getPropertyValue(p);
        // captions in the theme font can't load inside the picture; use a clean sans-serif instead
        if (p === 'font-family' && !/Helvetica Bold Craftmark/i.test(v)) v = 'Helvetica, Arial, sans-serif';
        if (v !== '') st += p + ':' + v + ';';
      });
      dst[i].setAttribute('style', st);
      dst[i].removeAttribute('class');
    }
    c.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    c.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
    if (!c.getAttribute('viewBox')) c.setAttribute('viewBox', '0 0 ' + r.width + ' ' + r.height);
    var h = Math.round(OUT_W * r.height / r.width);
    c.setAttribute('width', OUT_W); c.setAttribute('height', h);
    c.setAttribute('preserveAspectRatio', svg.getAttribute('preserveAspectRatio') || 'xMidYMid meet');
    var imgs = Array.prototype.slice.call(c.querySelectorAll('image'));
    return Promise.all(imgs.map(function (im) {
      var href = im.getAttribute('href') || im.getAttributeNS('http://www.w3.org/1999/xlink', 'href');
      if (!href || href.indexOf('data:') === 0) return null;
      return toDataUrl(new URL(href, location.href).href).then(function (d) {
        if (d) { im.setAttribute('href', d); im.removeAttributeNS('http://www.w3.org/1999/xlink', 'href'); }
      });
    })).then(function () { return { node: c, h: h }; });
  }

  function drawSvg(ctx, node, css, x, y, w, h) {
    if (css) {
      var st = document.createElementNS('http://www.w3.org/2000/svg', 'style');
      st.textContent = css; node.insertBefore(st, node.firstChild);
    }
    var xml = new XMLSerializer().serializeToString(node);
    return new Promise(function (ok) {
      var img = new Image();
      img.onload = function () { ctx.drawImage(img, x, y, w, h); ok(true); };
      img.onerror = function () { ok(false); };
      img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(xml);
    });
  }

  function designKey(list) {
    var form = document.querySelector('#add_button') && document.querySelector('#add_button').closest('form');
    var f = form ? Array.prototype.map.call(form.querySelectorAll('input,select,textarea'), function (i) {
      return i.name === 'properties[Design Preview]' ? '' : (i.name + '=' + (i.type === 'checkbox' || i.type === 'radio' ? i.checked : i.value));
    }).join('|') : '';
    return f + '#' + list.map(function (s) { return s.innerHTML.length; }).join(',');
  }

  // draw one preview on its own canvas, then crop away the empty white margin around it
  function renderPart(p, css) {
    var cv = document.createElement('canvas'); cv.width = OUT_W; cv.height = p.h;
    var ctx = cv.getContext('2d'); ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, cv.width, cv.height);
    return drawSvg(ctx, p.node, css, 0, 0, OUT_W, p.h).then(function () {
      var d = ctx.getImageData(0, 0, cv.width, cv.height).data, x0 = cv.width, y0 = cv.height, x1 = -1, y1 = -1;
      for (var y = 0; y < cv.height; y++) for (var x = 0; x < cv.width; x++) {
        var k = (y * cv.width + x) * 4;
        if (d[k] < 242 || d[k + 1] < 242 || d[k + 2] < 242) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
      }
      if (x1 < 0) return null;
      var m = 10; x0 = Math.max(0, x0 - m); y0 = Math.max(0, y0 - m); x1 = Math.min(cv.width - 1, x1 + m); y1 = Math.min(cv.height - 1, y1 + m);
      return { cv: cv, x: x0, y: y0, w: x1 - x0 + 1, h: y1 - y0 + 1 };
    });
  }

  function snapshotBlob(list) {
    return loadFontCss().then(function (css) {
      return Promise.all(list.map(cloneSvg)).then(function (parts) {
        var chain = Promise.resolve([]);
        parts.forEach(function (p) { chain = chain.then(function (acc) { return renderPart(p, css).then(function (r) { if (r) acc.push(r); return acc; }); }); });
        return chain;
      }).then(function (crops) {
        if (!crops.length) throw 'empty';
        var W = Math.max.apply(null, crops.map(function (c) { return c.w; }));
        var H = PAD * 2 + crops.reduce(function (t, c) { return t + c.h; }, 0) + GAP * (crops.length - 1);
        var cv = document.createElement('canvas'); cv.width = W + PAD * 2; cv.height = H;
        var ctx = cv.getContext('2d'); ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, cv.width, cv.height);
        var y = PAD;
        crops.forEach(function (c) { ctx.drawImage(c.cv, c.x, c.y, c.w, c.h, PAD + Math.round((W - c.w) / 2), y, c.w, c.h); y += c.h + GAP; });
        return new Promise(function (ok, bad) { cv.toBlob(function (b) { b ? ok(b) : bad('no blob'); }, 'image/png'); });
      });
    });
  }
  window.__cmSnapshot = function () { return snapshotBlob(targets()); }; // for testing

  function uploadSnapshot(list) {
    var key = designKey(list);
    if (snap.key === key && snap.url) return Promise.resolve(snap.url);
    var uc = window.uploadcare, pk = window.UploadKit && window.UploadKit.config && window.UploadKit.config.ucKey;
    if (!uc || !uc.fileFrom || !pk) return Promise.resolve(null);
    return snapshotBlob(list).then(function (blob) {
      var file = new File([blob], 'design-preview.png', { type: 'image/png' });
      return new Promise(function (ok) {
        var done = false, t = setTimeout(function () { if (!done) { done = true; ok(null); } }, 15000);
        uc.fileFrom('object', file, { publicKey: pk }).done(function (info) { if (done) return; done = true; clearTimeout(t); snap = { key: key, url: info.cdnUrl }; ok(info.cdnUrl); })
          .fail(function () { if (done) return; done = true; clearTimeout(t); ok(null); });
      });
    }).catch(function () { return null; });
  }

  function setPreviewProp(form, url) {
    var el = form.querySelector('input[name="properties[Design Preview]"]');
    if (!url) { if (el) el.remove(); return; }
    if (!el) { el = document.createElement('input'); el.type = 'hidden'; el.name = 'properties[Design Preview]'; form.appendChild(el); }
    el.value = url + '-/preview/1200x1200/';
  }

  window.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('#add_button');
    if (!b) return;
    if (passThrough) { passThrough = false; return; }
    if (document.getElementById('np-data')) return; // nameplate builder handles its own picture
    var form = b.closest('form'); if (!form) return;
    var list = targets(); if (!list.length) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (b.classList.contains('cm-saving')) return;
    var label = b.innerHTML; b.classList.add('cm-saving'); b.innerHTML = 'Saving your design…';
    uploadSnapshot(list).then(function (url) {
      setPreviewProp(form, url);
      b.classList.remove('cm-saving'); b.innerHTML = label;
      passThrough = true; b.click();
    });
  }, true);
})();
